// var onLineHttp = 'http://106.15.59.81:9876' ;
// var localhost = 'http://139.224.209.175:9998';
const buildInfo = require('./version.js');

let channelUrl = '';//location.protocol + '//' + location.host
let grpcUrl = '';

//整合
let api = 'http://label.newayz.com/annoplant';

let auth = 'http://oauth.newayz.com/show';
let appid = 'N5jfZmBN8weVjlJdil9C8I658';


let authInfo = 'http://oauth.newayz.com/oauth2';
let appSecret = 'KaxjcaYuNm8QIw1l1HghQMmPBng';
if (window.location.host !== 'label.newayz.com') {
  api = 'http://172.3.0.7:8080/annoplant'
  appid = '2qOvUdnLbzTBT6OE0KrG9nTiSI'
}
//end

if (process.env.CHANNEL === 'hd-prod1') {
  // TODO: Temp!
  channelUrl = 'http://172.3.0.56:7000';
} else if (process.env.CHANNEL === "hd-qa1") {
  channelUrl = 'http://hd-qa1-ts.newayz.com:7000';
} else if (process.env.CHANNEL === "hd-dev1") {
  channelUrl = 'http://hd-dev1-ts.newayz.com:7000';
} else if (process.env.CHANNEL === "offline") {
  channelUrl = '/litedata';
  grpcUrl = 'http://192.168.1.187:8080';
} else {
  // Defaults to maphouse
  channelUrl = 'http://maphouse-ts.newayz.com:7000';
}

if (window.OVERRIDE_GRPC_URL) {
  console.log("found override grpc url: " + window.OVERRIDE_GRPC_URL);
  grpcUrl = window.OVERRIDE_GRPC_URL;
}


const docTitle = `WAYZ-HDMap(${process.env.CHANNEL})`;

module.exports = {
  // ONLINE_HTTP: 'http://106.15.57.39:9876',
  // STATIC_URL: 'http://139.224.209.175:9997',
  CHANNEL: channelUrl,
  GRPC_URL: grpcUrl,
  DOC_TITLE: docTitle,
  // API_GLOBAL_EARTH: 'http://api.globalearth.net:8301',
  // STATIC_URL: 'http://localhost:3000/assets/img',
  API: api,
  AUTH_URL: auth,
  APPID: appid,
  APP_SECRET: appSecret,
  AUTH_INFO: authInfo,

  VERSION: buildInfo.VERSION,
  GIT_MERGE: buildInfo.GIT_MERGE,
  GIT_CHASH: buildInfo.GIT_CHASH,
}


// WEBPACK FOOTER //
// ./src/constants/conf.js